module.exports = __webpack_public_path__ + "static/media/tipologia4.d528fd97.png";